$(".top-header-slider").slick({
  autoplay: true,
  autoplaySpeed: 0,
  speed: 22000,
  arrows: false,
  swipe: false,
  slidesToShow: 2,
  cssEase: "linear",
  pauseOnFocus: false,
  pauseOnHover: false,
  variableWidth: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        speed: 26000,
      },
    },
  ],
});
$(".hero-slider").slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  autoplay: true,
  autoplaySpeed: 2000,
  prevArrow:
    '<button class="slide-arrow prev-arrow"><svg width="116" height="115" viewBox="0 0 116 115" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="58.0833" cy="57.3753" r="52.0271" fill="#F3F9FB" stroke="white" stroke-width="10.6722"/><path d="M62.7524 48.0372L53.4142 57.3754L62.7524 66.7136" stroke="#008ECC" stroke-width="2.00104" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
  nextArrow:
    '<button class="slide-arrow next-arrow"><svg width="116" height="115" viewBox="0 0 116 115" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="58.0833" cy="57.3753" r="52.0271" fill="#F3F9FB" stroke="white" stroke-width="10.6722"/><path d="M62.7524 48.0372L53.4142 57.3754L62.7524 66.7136" stroke="#008ECC" stroke-width="2.00104" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1, // Ensure only 1 slide is shown
        slidesToScroll: 1, // Ensure only 1 slide is scrolled
        autoplay: true,
      },
    },
  ],
});
// $(".featured-collection .product-grid").slick({
//   dots: false,
//   infinite: true,
//   speed: 300,
//   slidesToShow: 4,
//   slidesToScroll: 1,
//   arrows: false,
//   // centerMode: true,
//   centerPadding: "80px",
//   responsive: [
//     {
//       breakpoint: 1200,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 1,
//         infinite: true,
//         dots: false,
//         centerPadding: "60px",
//       },
//     },
//     {
//       breakpoint: 868,
//       settings: {
//         slidesToShow: 2, // Ensure only 1 slide is shown
//         slidesToScroll: 1, // Ensure only 1 slide is scrolled
//         centerPadding: "40px",
//         dots: false,
//       },
//     },
//     {
//       breakpoint: 559,
//       settings: {
//         slidesToShow: 1, // Ensure only 1 slide is shown
//         slidesToScroll: 1, // Ensure only 1 slide is scrolled
//         centerPadding: "40px",
//         dots: false,
//          centerMode: true,
//       },
//     },
//   ],
// });
// $(".prev-btn").click(function () {
//   $(".featured-collection .product-grid").slick("slickPrev");
// });

// $(".next-btn").click(function () {
//   $(".featured-collection .product-grid").slick("slickNext");
// });
// $(".prev-btn").addClass("slick-disabled");
// $(".featured-collection .product-grid").on("afterChange", function () {
//   if ($(".slick-prev").hasClass("slick-disabled")) {
//     $(".prev-btn").addClass("slick-disabled");
//   } else {
//     $(".prev-btn").removeClass("slick-disabled");
//   }
//   if ($(".slick-next").hasClass("slick-disabled")) {
//     $(".next-btn").addClass("slick-disabled");
//   } else {
//     $(".next-btn").removeClass("slick-disabled");
//   }
// });
// $(".slider-for").slick({
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   arrows: false,
//   asNavFor: ".slider-nav",
// });
// $(".slider-nav").slick({
//   slidesToShow: 3,
//   slidesToScroll: 1,
//   asNavFor: ".slider-for",
//   dots: true,
//   arrows: false,
//   focusOnSelect: true,
//   vertical: true,
//   responsive: [
//     {
//       breakpoint: 768,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 1,
//         vertical: false,
//       },
//     },
//     {
//       breakpoint: 576,
//       settings: {
//         slidesToShow: 3, // Ensure only 1 slide is shown
//         slidesToScroll: 1, // Ensure only 1 slide is scrolled
//         vertical: false,
//       },
//     },
//   ],
// });

$(document).ready(function () {
  $(".review-slider").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    infinite: false,
    autoplay: false,
    dots: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2, // Ensure only 1 slide is shown
          slidesToScroll: 1, // Ensure only 1 slide is scrolled
          dots: false,
        },
      },
      {
        breakpoint: 559,
        settings: {
          slidesToShow: 1, // Ensure only 1 slide is shown
          slidesToScroll: 1, // Ensure only 1 slide is scrolled
          dots: false,
        },
      },
    ],
  });
  $(".prev-btn").click(function () {
    $(".review-slider").slick("slickPrev");
  });

  $(".next-btn").click(function () {
    $(".review-slider").slick("slickNext");
  });
  $(".prev-btn").addClass("slick-disabled");
  $(".review-slider").on("afterChange", function () {
    if ($(".slick-prev").hasClass("slick-disabled")) {
      $(".prev-btn").addClass("slick-disabled");
    } else {
      $(".prev-btn").removeClass("slick-disabled");
    }
    if ($(".slick-next").hasClass("slick-disabled")) {
      $(".next-btn").addClass("slick-disabled");
    } else {
      $(".next-btn").removeClass("slick-disabled");
    }
  });
});


// Hide Elfsight "Free Google Reviews" badge
document.addEventListener("DOMContentLoaded", function () {
  function hideElfsightBadge() {
    const badge = document.querySelector('a[href*="elfsight.com/google-reviews-widget"]');
    if (badge) {
      badge.style.display = "none";
    }
  }

  // Run once on load
  hideElfsightBadge();

  // Watch for dynamically added elements
  const observer = new MutationObserver(hideElfsightBadge);
  observer.observe(document.body, { childList: true, subtree: true });
});



function styleNewArrival() {
  document.querySelectorAll('a[href="/collections/new-arrival"] > span')
    .forEach(el => {
      el.style.setProperty("padding", "0 60px 0 4px", "important");
      el.style.setProperty("color", "#003694", "important");
      el.style.setProperty("background-image", "url(https://cdn.shopify.com/s/files/1/2542/7564/files/sale.gif?v=1684739585)", "important");
      el.style.setProperty("background-repeat", "no-repeat", "important");
      el.style.setProperty("text-indent", "-9999999px", "important");
      el.style.setProperty("background-size", "contain", "important");

      // Responsive background-position
      if (window.innerWidth <= 991) {
        el.style.setProperty("background-position", "110px -1px", "important");
      } else {
        el.style.setProperty("background-position", "92px -1px", "important");
      }
    });
}

// Run on load + resize
document.addEventListener("DOMContentLoaded", styleNewArrival);
window.addEventListener("resize", styleNewArrival);




  document.addEventListener("DOMContentLoaded", function() {
    const mainModelSpan = document.getElementById('main-model-name');
    const originalModel = mainModelSpan.textContent;
    const relatedItems = document.querySelectorAll('.related-product-item');

    relatedItems.forEach(item => {
      const modelName = item.getAttribute('data-model-name');

      // On hover, update the main product model
      item.addEventListener('mouseenter', () => {
        mainModelSpan.textContent = modelName || 'No Model';
      });

      // On hover out, revert back to original main product model
      item.addEventListener('mouseleave', () => {
        mainModelSpan.textContent = originalModel;
      });
    });
  });


  document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll(".custom-description").forEach(function(desc) {
    const textBlock = desc.querySelector(".text");
    const button = desc.querySelector(".read-more-btn");
    
    // Only show button if text is taller than threshold
    if (textBlock.scrollHeight <= 160) {
      button.style.display = "none";
      return;
    }

    button.addEventListener("click", function() {
      desc.classList.toggle("expanded");
      button.textContent = desc.classList.contains("expanded") ? "Read less" : "Read more";
    });
  });
});


